class OpgroupSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onOpgroupChange);
    
  }

  onOpgroupChange() {
    this.updateURL();
    this.renderProductInfo();
  //   this.updateOptions();
  //   this.updateMasterId();
  //   this.toggleAddButton(true, '', false);
  //   this.updatePickupAvailability();
  //   this.removeErrorMessage();
  //   this.updateOpgroupStatuses();

  //   if (!this.currentOpgroup) {
  //     this.toggleAddButton(true, '', true);
  //     this.setUnavailable();
  //   } else {
  //     this.updateMedia();
  //     this.updateURL();
  //     this.updateOpgroupInput();
  //     this.renderProductInfo();
  //     this.updateShareUrl();
  //   }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentOpgroup = this.getOpgroupData().find((opgroup) => {
      return !opgroup.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentOpgroup) return;
    if (!this.currentOpgroup.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentOpgroup.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentOpgroup.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
     this.currentOpgroup = this.getOpgroupData();
    let opgroupInputs=this.querySelectorAll('input')
    for (let index = 0; index < opgroupInputs.length; index++) {
      const element=opgroupInputs[index];
      if (element.checked) {
        window.history.replaceState({}, '', `${element.dataset.url}`);
        //break;
      }
    }
    //if (!this.currentOpgroup || this.dataset.updateUrl === 'false') return;
    //window.history.replaceState({}, '', `${this.dataset.url}?opgroup=${this.currentOpgroup.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?opgroup=${this.currentOpgroup.id}`);
  }

  updateOpgroupInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentOpgroup.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateOpgroupStatuses() {
    const selectedOptionOneOpgroups = this.opgroupData.filter(
      (opgroup) => this.querySelector(':checked').value === opgroup.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneOpgroups
        .filter((opgroup) => opgroup.available && opgroup[`option${index}`] === previousOptionSelected)
        .map((opgroupOption) => opgroupOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.opgroupStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentOpgroup && this.currentOpgroup.available) {
      pickUpAvailability.fetchAvailability(this.currentOpgroup.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    //const requestedOpgroupId = this.currentOpgroup.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    
    let opgroupInputs=this.querySelectorAll('input');
    
    ////console.log(opgroupInputs);
    for (let index = 0; index < opgroupInputs.length; index++) {
      const element=opgroupInputs[index];
      if (element.checked) {
        //window.history.replaceState({}, '', `${element.dataset.url}`);
        ////console.log(`${element.dataset.url}`);
        fetch(
        `${element.dataset.url}`
      )
      .then((response) => response.text())
      .then((responseText) => {
        var scrollPos;
        if (typeof window.pageYOffset != 'undefined') {
            scrollPos = window.pageYOffset;
        }
        else if (typeof document.compatMode != 'undefined' && document.compatMode != 'BackCompat') {
            scrollPos = document.documentElement.scrollTop;
        }
        else if (typeof document.body != 'undefined') {
            scrollPos = document.body.scrollTop;
        }
        // prevent unnecessary ui changes from abandoned selections
        //if (this.currentOpgroup.id !== requestedOpgroupId) return;
        let accordionsOG=document.querySelectorAll("#optionsgruppe_radio_wrapper .accordion");
        //let oldReviews=document.queerySelectorAll(".jdgm-all-reviews-text").
       //  let oldReviews="";
       // if(document.querySelector(".jdgm-all-reviews-text")!= undefined)
       //  {
       //    oldReviews=document.querySelector(".jdgm-all-reviews-text").innerHTML;
       //  }
        let media_gallery_old=document.querySelector("media-gallery").innerHTML;
        ////console.log(media_gallery_old);
        
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        
        const elem = document.getElementById(element.id);
        const rect = elem.getBoundingClientRect();
        ////console.log(html);spinner_op_group
        document.querySelector("#MainContent").style.visibility="hidden";
         document.querySelector("#MainContent").style.opacity = 0;
        //document.querySelector("#spinner_op_group").style.display="block";
        document.querySelector("#MainContent").innerHTML=html.querySelector("#MainContent").innerHTML; 
        // if(document.querySelector(".jdgm-all-reviews-text")!= undefined)
        // {
        //   document.querySelector(".jdgm-all-reviews-text").innerHTML=oldReviews;
        // }
          
        //document.querySelector("media-gallery").innerHTML=media_gallery_old;
        //document.getElementById(element.id).scrollIntoView();
        setTimeout(function(){ 
          document.body.scrollTop=scrollPos;
          //window.scrollTo(0, 0);
          //window.scrollTo(rect.x, rect.y);
          // const y = element.getBoundingClientRect().top + window.scrollY;
          // window.scroll({
          //   top: y,
          //   behavior: 'smooth'
          // });
          //document.getElementById(element.id).scrollIntoView();
       // document.querySelector("#spinner_op_group").style.display="none";
          //window.scrollTo(rect.x, rect.y);
        document.querySelector("#MainContent").style.visibility="visible";
          
        document.querySelector("#MainContent").style.opacity = 1;
          var img = document.getElementById('hersteller-logo');
          if(img != undefined){
            img.onerror = function() {
              img.style.display = 'none';
            };
          }
          let accordionOGNew=document.querySelectorAll("#optionsgruppe_radio_wrapper .accordion");
          for (let index = 0; index < accordionsOG.length; index++) {
            const accordion=accordionsOG[index];
            if (accordion.classList.contains("open")) {
              accordionOGNew[index].classList.add("open");
            }
          }
           const slickTest=document.getElementsByClassName("slick_slider_kk");
            if(slickTest.length !=0)
            {
              $('.slick_slider_kk').each(function( index ) {
                let slidestoshowLarge=7;
                if($(this).data( "slidestoshow-large" )!= undefined)
                {
                  slidestoshowLarge=$(this).data( "slidestoshow-large" );
                }
                let slidestoshowMedium=4;
                if($(this).data( "slidestoshow-medium" )!= undefined)
                {
                  slidestoshowMedium=$(this).data( "slidestoshow-medium" );
                }
                $(this).slick({
                   dots: true,
                   appendDots: $(this).parent().find('.slider-navi'),
                   infinite:  true,
                   slidesToShow: slidestoshowLarge,
                   slidesToScroll: 1,
                   arrows: true,
                   accessibility: true,
          		variableWidth: true,
          		focusOnSelect: false,  
          		centerMode: false,
                   responsive: [
          			{
          				breakpoint: 1200,
          				settings: {
          					slidesToShow: slidestoshowMedium,
                              slidesToScroll: 1,
                              arrows: true,
                              dots: false,
          				}
          			},
                     {
          				breakpoint: 576,
          				settings: {
          					slidesToShow: 1,
                              slidesToScroll: 1,
                              arrows: false,
                              dots: false,
                              centerMode: true,
                              centerPadding: '90px',
          				}
          			}
          		]   
                 });
                 
                 const nextButton = $(this).parent().find('.next-btn');
                
                nextButton.on('click', function() {
                  const slickNextButton=$(this).closest('div[class^="slider-container"]').find('.slick-next');
                  slickNextButton.click();
                });
      
                const prevButton = $(this).parent().find('.prev-btn');
                
                prevButton.on('click', function() {
                  const slickPrevButton=$(this).closest('div[class^="slider-container"]').find('.slick-prev');
                  slickPrevButton.click();
                });
                
              });
              
            }
           var target2 = document.querySelector("product-recommendations");
            if (target2) {
              var observer = new MutationObserver(function (mutations) {
             const slickTestRelated=document.getElementsByClassName("slick_slider_kk_related");
            if(slickTestRelated.length !=0)
            {
              $('.slick_slider_kk_related').each(function( index ) {
                let slidestoshowLarge=7;
                if($(this).data( "slidestoshow-large" )!= undefined)
                {
                  slidestoshowLarge=$(this).data( "slidestoshow-large" );
                }
                let slidestoshowMedium=4;
                if($(this).data( "slidestoshow-medium" )!= undefined)
                {
                  slidestoshowMedium=$(this).data( "slidestoshow-medium" );
                }
                $(this).slick({
                   dots: true,
                   appendDots: $(this).parent().find('.slider-navi'),
                   infinite:  true,
                   slidesToShow: slidestoshowLarge,
                   slidesToScroll: 1,
                   arrows: true,
                   accessibility: true,
          		variableWidth: true,
          		focusOnSelect: false,  
          		centerMode: false,
                   responsive: [
          			{
          				breakpoint: 1200,
          				settings: {
          					slidesToShow: slidestoshowMedium,
                              slidesToScroll: 1,
                              arrows: true,
                              dots: false,
          				}
          			},
                     {
          				breakpoint: 576,
          				settings: {
          					slidesToShow: 1,
                              slidesToScroll: 1,
                              arrows: false,
                              dots: false,
                              centerMode: true,
                              centerPadding: '90px',
          				}
          			}
          		]   
                 });
                 
                 const nextButton = $(this).parent().find('.next-btn');
                
                nextButton.on('click', function() {
                  const slickNextButton=$(this).closest('div[class^="slider-container"]').find('.slick-next');
                  slickNextButton.click();
                });
      
                const prevButton = $(this).parent().find('.prev-btn');
                
                prevButton.on('click', function() {
                  const slickPrevButton=$(this).closest('div[class^="slider-container"]').find('.slick-prev');
                  slickPrevButton.click();
                });
                
              });
            }
              
            });
      
              observer.observe(target2, {
                attributes: true,
                childList: true,
                characterData: true,
              });
            }
          const quickadds = document.querySelectorAll(".kk-quick_add");
    
          //add named functions that get the newID as parameter
          var dragmovement = 0;
          const downListener = () => {
            dragmovement = 0;
          }
          const moveListener = () => {
              dragmovement++;
          }
          const upListener = () => {
            if (dragmovement > 7) {
            } else {
            }
          }
          quickadds.forEach((accordion) => {
            accordion.addEventListener('mousedown', downListener);
            accordion.addEventListener('mousemove', moveListener);
            accordion.addEventListener("click", function(event){
                event.preventDefault();});
            accordion.addEventListener("mouseup", function(event){
              //console.log(dragmovement);
                event.preventDefault();
              if (dragmovement < 20) {
                //console.log(this.dataset);
                fetch('/cart/add.js', {
                method: 'POST',
                  headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json'
                  },
                   body: JSON.stringify({id:this.dataset.id,quantity:this.dataset.quantity,productId:this.dataset.productId})
                })
                 .then(response => response.json())
                 .then(response => {
                   //console.log(JSON.stringify(response));
                   //console.log(JSON.stringify(this.dataset));
                   let addedProduct=response;
                   // document.querySelectorAll(".cart-notification-quicckadd-kk").forEach((quicckadd) => {
                   //   quicckadd.innerHTML="";
                   // });
                   let newWarenkorb=parseInt( document.querySelector(".cart-count-kk").innerHTML.replace("(","").replace(")","") ) + 1;
                   document.getElementById("quick_add_kk_notification-"+this.dataset.sectionId+"-"+this.dataset.productId).innerHTML = `
                   <div class="cart-notification-quicckadd-kk" aria-modal="true" aria-label="Artikel wurde in den Warenkorb gelegt">
                          <div class="cart-notification__header">
                            <h2 class="cart-notification__heading caption-large text-body"><svg class="icon icon-checkmark" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z" fill="currentColor"></path>
                    </svg>
                    Artikel wurde in den Warenkorb gelegt
                            </h2>
                            <button type="button" class="cart-notification__close modal__close-button link link--text focus-inset" aria-label="Schließen">
                              <svg class="icon icon-close" aria-hidden="true" focusable="false">
                                <use href="#icon-close">
                              </use></svg>
                            </button>
                          </div>
                          <div id="cart-notification-product" class="cart-notification-product"><div class="cart-notification-product__image global-media-settings">
                              <img src="`+addedProduct.image+`&amp;width=140" alt="" width="70" height="94" loading="lazy">
                            </div><div><h3 class="cart-notification-product__name h4">`+addedProduct.title+`</h3></div>
                        </div>
                          <div class="cart-notification__links">
                            <a href="/cart" id="cart-notification-button" target="_blank" class="button button--secondary button--full-width">Warenkorb ansehen (` + newWarenkorb + `)</a>
                            
                            <button type="button" class="link button-label">Weiter shoppen</button>
                          </div>
                        </div>`;
                   var newID="quick_add_kk_notification-"+this.dataset.sectionId+"-"+this.dataset.productId;
                   document.querySelector("#quick_add_kk_notification-"+this.dataset.sectionId+"-"+this.dataset.productId +" .icon-close").addEventListener("click", function(event){
                     document.getElementById(newID).innerHTML="";
                   }, { once: true });
                   document.querySelector("#quick_add_kk_notification-"+this.dataset.sectionId+"-"+this.dataset.productId +" .cart-notification__links .link.button-label").addEventListener("click", function(event){
                     document.getElementById(newID).innerHTML="";
                     //this.removeEventListener
                   }, { once: true });
                   document.querySelector("body").addEventListener("click", function(event){
                      const target = event.target;
                       //console.log("test");
                      if (target !== newID && !target.closest('#'+newID)) {
                        document.getElementById(newID).innerHTML="";
                      }
                   }, { once: true });
                 }
                );
              } else {
              }
              dragmovement=0;
            });
          });
          productPageHandle();
          
          

          //console.log("KK NACHLADEN DER APPS OV");
          
          //document.querySelector(".jdgm-all-reviews-text").innerHTML=oldReviews;
          ////console.log(oldReviews);
          // Gravur Plugin
          window.Cloudlift.options.App.setup(true);
          
          window.addEventListener('options:rendered', function(e) {
              // print the option to the console
              //console.debug('options rendered', e.detail);
              var optionEl = document.querySelector('[data-option="_Button"]');
              if(optionEl){
                  document.querySelector("#gravur_accordion .op-wrapper-head p").innerHTML=document.querySelectorAll("#personalization-kk .cl-po--swatch")[0].innerHTML;
                document.querySelector(".person-kk").style.display = "block";
              }
          }, { once: true }); // only runs once to get the element reference
          
          // Monk App (Crossselling)
          document.documentElement.dispatchEvent(
            new CustomEvent('mr:productChange', {
            bubbles: true,
            }),
          );
         // Judge App (Kundenbewertungen)
       setTimeout(() => {
          //jdgmCacheServer.reloadAll();
        }, 400)
          

 
          //Custom script neu einfügen
          //Versuch Skripte neu zu laden
          /*
          var oldScripts = document.querySelectorAll('#MainContent script');
          var oldScriptsRemove=[];
          var newScriptsAdd=[];

          for (let i = 0; i < oldScripts.length; ++i) {
            if(oldScripts[i].src!="")
            {
              let new_src=oldScripts[i].src;
              document.querySelector('script').remove();
              oldScriptsRemove.push(i);
              newScriptsAdd.push(new_src);
              // var script= document.createElement('script');
              // script.src= new_src;
              // head.appendChild(script);
            }
          }
          for (let index = oldScriptsRemove.length-1; index >=0; index--) {
            document.querySelectorAll('#MainContent script')[oldScriptsRemove[index]].remove();
          }
          for (let index = 0; index < newScriptsAdd.length; index++) {
            var script= document.createElement('script');
              script.src= newScriptsAdd[index];
              document.getElementById("MainContent").appendChild(script);
          }*/
          // document.querySelector('#MainContent script')
          // //console.log(document.querySelector('#MainContent script'));
          // //console.log(document.querySelector('#MainContent script').src);
          //var head= document.getElementsByTagName('head')[0];
          //let new_src=document.querySelector('script').src;
          //document.querySelector('script').remove();
          //var script= document.createElement('script');
          //script.src= new_src;
          //head.appendChild(script);
        // $('script[src="' + src + '"]').remove();
        // $('<script>').attr('src', src).appendTo('#MainContent');
          //Bewertungen öffnen
          const toggleButton = document.querySelector(".toggle-button-des");
          const accordion = document.querySelector(".decription-accordion");
          if(toggleButton != undefined)
          {
            toggleButton.addEventListener("click", function() {
              accordion.classList.toggle("active");
              toggleButton.textContent = accordion.classList.contains("active") ? "Weniger anzeigen" : "Mehr anzeigen";
            });
          }
          //Accordion OP-Group
          const accordions = document.querySelectorAll(".accordion");
    

          accordions.forEach((accordion) => {
            const header = accordion.querySelector(".accordion-header");
      
            header.addEventListener("click", () => {
              
              if(header.id=="gravur_accordion")
              {
                
                if (accordion.classList.contains("open")) {
                  // Wenn das Accordion bereits geöffnet ist, schließe es
                  document.querySelector("#gravur_accordion .op-wrapper-head p").innerHTML=document.querySelectorAll("#personalization-kk .cl-po--swatch")[0].innerHTML;
                  document.querySelectorAll("#personalization-kk .cl-po--swatch")[1].click();
                  //accordion.classList.remove("open");
                } else {
                  
                  document.querySelector("#gravur_accordion .op-wrapper-head p").innerHTML=document.querySelectorAll("#personalization-kk .cl-po--swatch")[1].innerHTML;
                  document.querySelectorAll("#personalization-kk .cl-po--swatch")[0].click();
                  //accordion.classList.add("open");
                }
                
              }
              if (accordion.classList.contains("open")) {
                // Wenn das Accordion bereits geöffnet ist, schließe es
                accordion.classList.remove("open");
              } else {
                // Schließe zuerst alle Accordions
                accordions.forEach((item) => {
                  item.classList.remove("open");
                });
      
                // Öffne das angeklickte Accordion
                accordion.classList.add("open");
              }
            });
                  
          });
          const accordionsVar = document.querySelectorAll("variant-selects .accordion");

            accordions.forEach((accordion) => {
              const header = accordion.querySelector(".accordion-header");
              const content = accordion.querySelector(".accordion-content");
        
              header.addEventListener("click", function () {
                if (content.style.display === "none" || content.style.display === "") {
                  content.style.display = "block";
                } else {
                  content.style.display = "none";
                }
              });
            });
        //loader disablen
          //document.querySelector("#loader-op-group ").style.display = "none";
          
        }, 0);
        
        //document.querySelector("body").style.display="grid";
        // document.open();
        // document.write(responseText);
        // document.close();
        // const destination = document.getElementById(`price-${this.dataset.section}`);
        // const source = html.getElementById(
        //   `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        // );
        // const skuSource = html.getElementById(
        //   `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        // );
        // const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        // const inventorySource = html.getElementById(
        //   `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        // );
        // const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        // if (source && destination) destination.innerHTML = source.innerHTML;
        // if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        // if (skuSource && skuDestination) {
        //   skuDestination.innerHTML = skuSource.innerHTML;
        //   skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        // }

        // const price = document.getElementById(`price-${this.dataset.section}`);

        // if (price) price.classList.remove('visibility-hidden');

        // if (inventoryDestination)
        //   inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        // const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        // this.toggleAddButton(
        //   addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
        //   window.opgroupStrings.soldOut
        // );
      });
       //break;
      }
    }
    //console.log("THIS FIRE ON CLICK ON CHANGE VARIATION OV / KK");
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.opgroupStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.opgroupStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getOpgroupData() {
    this.opgroupData = this.opgroupData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    
    return this.opgroupData;
  }
}

customElements.define('opgroup-selects', OpgroupSelects);

class OpgroupRadios extends OpgroupSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

  // if (localStorage.getItem("op_gruppen-quote-scroll") != null) {
  //     window.scrollTo(0, localStorage.getItem("op_gruppen-quote-scroll"));
  // }

  // window.onscroll = function(){
  //     localStorage.setItem("op_gruppen-quote-scroll", document.body.scrollTop);
  //     //console.log(localStorage.getItem("op_gruppen-quote-scroll"));
  // };
// window.onbeforeunload = function () {
//         var scrollPos;
//         if (typeof window.pageYOffset != 'undefined') {
//             scrollPos = window.pageYOffset;
//         }
//         else if (typeof document.compatMode != 'undefined' && document.compatMode != 'BackCompat') {
//             scrollPos = document.documentElement.scrollTop;
//         }
//         else if (typeof document.body != 'undefined') {
//             scrollPos = document.body.scrollTop;
//         }
//         const optionsgruppe_radio_wrapper=document.getElementById("optionsgruppe_radio_wrapper");
//         if (optionsgruppe_radio_wrapper != undefined) {
//          localStorage.setItem("op_gruppen-quote-scroll", scrollPos);
//         }
//         else
//         {
//           localStorage.removeItem("op_gruppen-quote-scroll");
//         }
//     }

// window.onload = function () {
//   //console.log(localStorage.getItem("op_gruppen-quote-scroll"));
//     if (localStorage.getItem("op_gruppen-quote-scroll") != null) {
//       document.documentElement.scrollTop = localStorage.getItem("op_gruppen-quote-scroll");
//       document.body.scrollTop = localStorage.getItem("op_gruppen-quote-scroll");
//       localStorage.removeItem("op_gruppen-quote-scroll");
//       document.querySelector(
//                     "#loader-op-group ").style.display = "none";
//     }
//     //product_custom_body
//     const product_custom_body=document.getElementById("product_custom_body");
//     if(product_custom_body != undefined)
//     {
//       document.querySelector("#product_custom_body").style.visibility = "visible";
//     document.querySelector("#product_custom_body").style.opacity = 1;
//     }
// }

// if (localStorage.getItem("op_gruppen-quote-scroll") != null) {
//     document.querySelector(
//         "#loader-op-group").style.visibility = "visible";
//     document.querySelector("#loader-op-group").style.opacity = 1;
// }
// else
// {
//   const loaderOpGroup=document.getElementById("loader-op-group");
//   if(loaderOpGroup != undefined)
//   {
//     document.querySelector("#loader-op-group").style.display = "none";
//   }
//   //product_custom_body
//   const product_custom_body=document.getElementById("product_custom_body");
//   if(product_custom_body != undefined)
//   {
//     document.querySelector("#product_custom_body").style.visibility = "visible";
//     document.querySelector("#product_custom_body").style.opacity = 1;
//   }
    
// }

customElements.define('opgroup-radios', OpgroupRadios);

window.addEventListener('options:rendered', function(e) {
    // print the option to the console
    //console.debug('options rendered', e.detail);
    var optionEl = document.querySelector('[data-option="_Button"]');
    if(optionEl){
        document.querySelector("#gravur_accordion .op-wrapper-head p").innerHTML=document.querySelectorAll("#personalization-kk .cl-po--swatch")[0].innerHTML;
      document.querySelector(".person-kk").style.display = "block";
    }
}, { once: true }); // only runs once to get the element reference
